import Vue from 'vue'
import ToasterService from '@/services/toasterService'

/**
 * The directive allows to enter into input only digits
 */
Vue.directive('digitsOnly', {
  bind (el, binding, vnode) {
    el.addEventListener('keydown', (e) => {
      if ([46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && e.ctrlKey === true) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && e.ctrlKey === true) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault()
      }
    })
  }
})

/**
 * The directive show message if dropdown doesn't have any options
 */
Vue.directive('no-options-message', {
  componentUpdated (el, binding, vnode) {
    const message = binding.value
    const listener = () => {
      ToasterService.showToast(ToasterService.INFO_TYPE, message)
    }
    el.removeEventListener('click', listener)

    const option = vnode?.componentOptions?.propsData?.options || []
    if (!option.length) {
      el.addEventListener('click', listener)
    }
  }
})

/**
 * The directive allows to attach arbitrary data to any HTML component
 */
Vue.directive('payload', {
  bind (el, binding, vnode) {
    el.dataset.event = JSON.stringify(binding.value)
  }
})
const arrayOfEvents = ['click', 'touchstart', 'touchmove', 'touchend', 'mousedown', 'mousemove', 'mouseup']
Vue.directive('stop-draggable', {
  bind (el) {
    el.style.userSelect = 'text'
    for (let event of arrayOfEvents) {
      el.addEventListener(event, (event) => {
        event.stopPropagation()
      })
    }
  },
  unbind (el) {
    for (let event of arrayOfEvents) {
      el.removeEventListener(event, (event) => {
        event.stopPropagation()
      })
    }
  }
})

Vue.directive('rfx-tooltip', {
  update: function (el, binding) {
    const uniqId = Math.random().toString(36).substring(7)
    el.addEventListener('mouseenter', () => {
      if (!document.getElementById(uniqId)) {
        const tooltipWrapper = document.createElement('div')
        tooltipWrapper.innerHTML = binding.value.html
        const viewportOffset = el.getBoundingClientRect()
        tooltipWrapper.style.position = 'absolute'
        tooltipWrapper.style.maxWidth = '255px'
        tooltipWrapper.id = uniqId
        document.body.appendChild(tooltipWrapper)
        tooltipWrapper.style.top = window.scrollY + viewportOffset.top - tooltipWrapper.offsetHeight - 25 + 'px'
        tooltipWrapper.style.left = viewportOffset.left - tooltipWrapper.offsetWidth / 2 + 7 + 'px'
      }
    })
    el.addEventListener('mouseleave', () => {
      const tooltipWrapper = document.getElementById(uniqId)
      tooltipWrapper && tooltipWrapper.remove()
    })
  }
})
